import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class SerialNumbers_ds_get_serialnumbers_by_serialNumberIdsService {

  constructor(
    private utils: UtilsService,
    private settings: SettingsValuesService,
    ) { 
  }

  public async get(inParams: { serialNumberIds: number[] }): 
  Promise<{ result: { Id?: number, Archived?: boolean, ChainHead?: number, LicensePlateId?: number, LookupCode?: string, LotId?: number, PackagingId?: number, StatusId?: number, Lot?: { MaterialId?: number, Material?: { ScanSerialOfAllPackageLevels?: boolean } }, ChildSerialNumbers?: { Id?: number }[] }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.serialNumberIds)) {
      missingRequiredInParams.push('\'serialNumberIds\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/SerialNumbers/datasources/ds_get_serialnumbers_by_serialNumberIds/get`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getList(inParams: { serialNumberIds: number[], $top?: number, $skip?: number }): 
  Promise<{ result: { Id?: number, Archived?: boolean, ChainHead?: number, LicensePlateId?: number, LookupCode?: string, LotId?: number, PackagingId?: number, StatusId?: number, Lot?: { MaterialId?: number, Material?: { ScanSerialOfAllPackageLevels?: boolean } }, ChildSerialNumbers?: { Id?: number }[] }[], totalCount: number }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.serialNumberIds)) {
      missingRequiredInParams.push('\'serialNumberIds\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/SerialNumbers/datasources/ds_get_serialnumbers_by_serialNumberIds/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { serialNumberIds: number[], $keys: number[] }): 
  Promise<{ result: { Id?: number, Archived?: boolean, ChainHead?: number, LicensePlateId?: number, LookupCode?: string, LotId?: number, PackagingId?: number, StatusId?: number, Lot?: { MaterialId?: number, Material?: { ScanSerialOfAllPackageLevels?: boolean } }, ChildSerialNumbers?: { Id?: number }[] }[] }> 
  {
    const missingRequiredInParams = [];
    if (isNil(inParams.serialNumberIds)) {
      missingRequiredInParams.push('\'serialNumberIds\'');
    }
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/SerialNumbers/datasources/ds_get_serialnumbers_by_serialNumberIds/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.utils.http.post(url, body, options);
    
  }


    
    hasMissingRequiredInParams(inParams: { 
      serialNumberIds: number[]    }) {
        if(isNil(inParams.serialNumberIds)) {
          return true; 
        }
      return false;
    }
}
